import React from 'react';
import PropTypes from 'prop-types';

import List from '../../helpers/List';

import WebinarForm from './WebinarForm';

const WebinarContent = ({
    t, openPage, language, webinar, consents
}) => (
    <div className="container-webinar-content" id="container-webinar-content">
        <div className="layout">
            <div className="page-webinar-content" id="page-webinar-content">
                <div className="webinar-content" id="webinar-content">
                    <div className="webinar-content-title" id="webinar-content-title">{ webinar.content.title }</div>
                    <ul
                      className="webinar-content-list"
                    >
                        <List data={ webinar.content.list }/>
                    </ul>
                    <div
                      className="webinar-content-bottom"
                      id="webinar-content-bottom"
                      dangerouslySetInnerHTML={ { __html: webinar.content.bottom_text } }
                    />
                </div>
                <WebinarForm
                  t={ t }
                  openPage={ openPage }
                  language={ language }
                  webinar={ webinar }
                  consents={ consents }
                />
            </div>
        </div>
    </div>
);

WebinarContent.propTypes = {
    t: PropTypes.func.isRequired,
    openPage: PropTypes.func.isRequired,
    language: PropTypes.string.isRequired,
    webinar: PropTypes.shape().isRequired,
    consents: PropTypes.objectOf(Object).isRequired
};

export default WebinarContent;



// WEBPACK FOOTER //
// ./src/components/content/webinar/WebinarContent.jsx